export default "__VITE_ASSET__0KPuSWJs__"